import { useMemo } from 'react'
import { INPOST_METHOD } from 'modules/checkout/constants'
import { CheckoutCartResponse } from '_app/graphql/types'

export const useFormValues = (data: CheckoutCartResponse | undefined) => {
  const isFakeAddress =
    data?.cart?.shipping_addresses[0]?.firstname === 'firstname'

  const shippingMethod =
    data?.cart?.shipping_addresses[0]?.selected_shipping_method

  const isInpostOrShowroom = useMemo(() => {
    const method = shippingMethod?.method_code || ''

    return ['showroom', INPOST_METHOD].includes(method)
  }, [shippingMethod])

  const isInpost = useMemo(() => {
    const method = shippingMethod?.method_code || ''

    return method === INPOST_METHOD
  }, [shippingMethod])

  return {
    isFakeAddress,
    isInpost,
    isInpostOrShowroom,
    shippingMethod,
  }
}
